import React, { PureComponent } from "react";
import SimpleBottomNavigation from "./components/SimpleBottomNav";
import { Route } from "react-router-dom";
import { withRouter } from "react-router-dom";
import VerticalSpace from "./components/VerticalSpace";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import AppConfig from "../../config/appconfig.json";
import KBELogo from "../account/img/kbe-Logo-66454.png";

/*
this is the object from this.props.location.state.airconsystem

{\"Sid\":\"20180910r5IaazWjEKoh\",\"Name\":\"\",\"Client\":\"20180824dd4Hv70cbn3k\",\"CustomerType\":\"\",\"Company\":\"\",
\"ContactPerson\":\"\",\"Brand\":\"Brand 1\",\"Model\":\"Model 1\",\"Type\":\"Inverter\",\"Fancoils\":\"2\",\"PostalCode\":\"123456\",
\"Block\":\"1\",\"Unit\":\"Unit 1\",\"Street\":\"Street 1\",\"Building\":\"\",\"MobileNo\":\"\",\"Email\":\"\",
\"LastServicing\":\"N.A\",\"ServicingDue\":\"N.A\"}
*/

class AirConDetails extends PureComponent {
  constructor(props) {
    super(props);
    const systemName = this.props.location.state.airconsystem.Brand + ' ' + this.props.location.state.airconsystem.Type + ' ' + this.props.location.state.airconsystem.Model;
    const addressLoc = this.props.location.state.airconsystem.Street + ' ' + this.props.location.state.airconsystem.Block + ' ' + this.props.location.state.airconsystem.PostalCode;
    this.state = {
      airconsystem: this.props.location.state.airconsystem,
      system: systemName,
      address: addressLoc,
      amountPaid: "",
      appointmentDate: "",
      scheduleSid: "",
      serviceBooked: "",
      serviceTeam: "",
      status: "",
      showFeedbackArea: false,
      isApptNotFound: true,
      NEXT_APPT: "Next Appointment",
      LAST_APPT: "Last Appointment",
      NOT_FOUND_APPT: "Appointment Not Found",
      feedback: "",
      isFeedbackSent: false
    };
    // console.log(this.state.airconsystem);
    this.onFeedbackChange = this.onFeedbackChange.bind(this);
  }

  componentDidMount() {
    if (this.state.airconsystem) {
      let isCheckApptFailed = false;
      // Call Back-End Services
      fetch(
        `${AppConfig.BACK_END_URL}/APIAppt/CheckAppt?systemSid=` +
        this.state.airconsystem.Sid
      )
        .then(response => {
          // console.log(response);
          if (response.ok === false) {
            isCheckApptFailed = true;
          }
          return response.json();
        })
        .then(json => {
          if (isCheckApptFailed) {
            const sys = localStorage.getItem(this.state.airconsystem.Sid);
            if (sys) {
              const respObj = JSON.parse(sys);
              this.setState({
                system: respObj.System,
                address: respObj.Address,
                amountPaid: respObj.AmountPaid,
                appointmentDate: respObj.AppointmentDate,
                scheduleSid: respObj.ScheduleSid,
                serviceBooked: respObj.ServiceBooked,
                serviceTeam: respObj.ServiceTeam,
                status: respObj.Status,
                isApptNotFound: respObj.Status === this.state.NOT_FOUND_APPT
              });
            }
          } else {
            const respObj = JSON.parse(json);
            // console.log(respObj);
            if (respObj.length > 0) {
              localStorage.setItem(this.state.airconsystem.Sid, JSON.stringify(respObj[0]));
              this.setState({
                system: respObj[0].System,
                address: respObj[0].Address,
                amountPaid: respObj[0].AmountPaid,
                appointmentDate: respObj[0].AppointmentDate,
                scheduleSid: respObj[0].ScheduleSid,
                serviceBooked: respObj[0].ServiceBooked,
                serviceTeam: respObj[0].ServiceTeam,
                status: respObj[0].Status,
                isApptNotFound: respObj[0].Status === this.state.NOT_FOUND_APPT
              });
            }
          }
        })
        .catch(() => {
          console.log(
            "Something went wrong when checking appointment. Please try again."
          );
          const sys = localStorage.getItem(this.state.airconsystem.Sid);
          if (sys) {
            const respObj = JSON.parse(sys);
            this.setState({
              system: respObj.System,
              address: respObj.Address,
              amountPaid: respObj.AmountPaid,
              appointmentDate: respObj.AppointmentDate,
              scheduleSid: respObj.ScheduleSid,
              serviceBooked: respObj.ServiceBooked,
              serviceTeam: respObj.ServiceTeam,
              status: respObj.Status,
              isApptNotFound: respObj.Status === this.state.NOT_FOUND_APPT
            });
          }
        });
    }
  }

  onFeedbackChange(e) {
    // console.log(e.target.value);
    this.setState({ feedback: e.target.value });
  }

  render() {
    const BookAppointmentButton = props => (
      <Route
        render={({ history }) => (
          <div>
            <Button
              variant="outlined"
              style={{ width: "100%" }}
              onClick={() => {
                history.push({
                  pathname: "/register_appt",
                  state: { airconsystem: this.state.airconsystem }
                });
                //console.log(this.state.airconsystem);
              }}
            >
              Book Appointment
            </Button>
          </div>
        )}
      />
    );

    const ChangeAppointmentButton = props => (
      <Route
        render={({ history }) => (
          <div>
            <Button
              variant="outlined"
              style={{ width: "100%" }}
              onClick={() => {
                history.push({
                  pathname: "/change_appt",
                  state: { airconsystem: this.state.airconsystem, ScheduleSid: this.state.scheduleSid, AppointmentDate: this.state.appointmentDate, System: this.state.system, Address: this.state.address }
                });
              }}
            >
              Change Appointment
            </Button>
          </div>
        )}
      />
    );

    const FeedbackButton = props => (
      <Route
        render={({ history }) => (
          <div>
            <Button
              variant="outlined"
              style={{ width: "100%" }}
              onClick={() => {
                this.setState({ showFeedbackArea: true });
              }}
            >
              Feed back
            </Button>
          </div>
        )}
      />
    );

    const FeedbackButtonSubmit = props => (
      <Route
        render={({ history }) => (
          <div>
            <Button
              variant="outlined"
              style={{ width: "100%" }}
              onClick={() => {
                if (this.state.scheduleSid) {
                  // console.log(this.state.feedback);
                  const request = {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ ScheduleSid: this.state.scheduleSid, Feedback: this.state.feedback })
                  };
                  // console.log(request);
                  let isPOSTFeedbackFailed = false;
                  // Call Back-End Services
                  fetch(`${AppConfig.BACK_END_URL}/APIAppt/PostFeedback`, request)
                    .then(response => {
                      // console.log(response);
                      if (response.ok === false) {
                        isPOSTFeedbackFailed = true;
                      }
                      return response.json();
                    })
                    .then(json => {
                      if (isPOSTFeedbackFailed) {
                      } else {
                        const respObj = JSON.parse(json);
                        // console.log(respObj);
                        if (respObj) {
                          this.setState({ isFeedbackSent: true })
                        }
                      }
                      this.setState({ showFeedbackArea: false });
                    })
                    .catch(() => {
                      console.log(
                        "Something went wrong when submitting appointment. Please try again."
                      );
                      this.setState({ showFeedbackArea: false });
                    });
                }
              }}
            >
              Submit
            </Button>
          </div>
        )}
      />
    );

    return (
      <div>
        <div className="account">
          <div className="account__wrapper">
            <div className="account__card">
              <div className="account__head">
                <img src={KBELogo} alt="logo" />
              </div>
              <div className="card__title">
                <center>
                  <h4 className="bold-text">Last Servicing Record</h4>
                </center>
                <br />
              </div>
              <form className="form form--horizontal">
                <div className="form__form-group">
                  <span>
                    System: <b>{this.state.system}</b>
                  </span>
                </div>
                <div className="form__form-group">
                  <span>
                    Address: <b>{this.state.address}</b>
                  </span>
                </div>
                <div className="form__form-group">
                  <span>Status: <b>{this.state.status}</b></span>
                </div>
                <div className="form__form-group">
                  <span>Appointment Date/Time: <b>{this.state.appointmentDate}</b></span>
                </div>
                <div className="form__form-group">
                  <span>Service Team: <b>{this.state.serviceTeam}</b></span>
                </div>
                <div className="form__form-group">
                  <p>Service(s) booked: </p>
                  <p><b>{this.state.serviceBooked}</b></p>
                </div>
                <div className="form__form-group">
                  <p>Total Amount Paid: <b>{this.state.amountPaid}</b></p>
                </div>
                {this.state.showFeedbackArea ? (
                  <div className="form__form-group">
                    <Grid container spacing={24}>
                      <Grid item xs={12}>
                        <textarea
                          name="feedback"
                          placeholder="Please enter your feedback"
                          value={this.state.feedback}
                          onChange={this.onFeedbackChange}
                          required
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <FeedbackButtonSubmit />
                      </Grid>
                    </Grid>
                  </div>
                ) : (
                    <div className="form__form-group">
                      {this.state.isApptNotFound ? (
                        <Grid container spacing={24}>
                          <Grid item xs={12}>
                            <BookAppointmentButton />
                          </Grid>
                        </Grid>
                      ) : (
                          <Grid container spacing={24}>
                            {this.state.status === this.state.NEXT_APPT ? (
                              <Grid item xs={12}>
                                <ChangeAppointmentButton />
                                <br />
                                <span>(Note: For appointment cancellation, please kindly contact KBE staff at 6506 7330.)</span>
                              </Grid>
                            ) : (
                                <Grid item xs={12}>
                                  <FeedbackButton />
                                  {this.state.isFeedbackSent ? (
                                    <center><span className="text-green">Feedback was sent. Thank you!</span></center>) : (<div />)}<br />
                                  <BookAppointmentButton />
                                </Grid>
                              )
                            }
                          </Grid>
                        )}
                    </div>
                  )}
                <VerticalSpace />
              </form>
              <SimpleBottomNavigation />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(AirConDetails);



// WEBPACK FOOTER //
// ./src/pages/main/AirConDetails.js